module.exports = __webpack_public_path__ + "img/sort-up.8821a449.png";